import { Data } from 'signup-constants/signupData/Data';
import { companyInfo } from '../http-company-info/CompanyInfoClient';
import { handleCompanyInfoError, handleCompanyInfoSuccess } from '../http-company-info/handleCompanyInfoResponse';
import { getRecommendedHublet } from '../hublets/getRecommendedHublet';
import { getVerificationType } from '../store/app/selectors';
import { FlowActionTypes } from '../store/flow/action-types';
import { isStepInNextOrCurrentStep } from '../store/flow/selectors';
import { setSignupDataValue } from '../store/signup-data/action-creators';
import { VisitorContextActionTypes } from '../store/visitor-context/action-types';
import { Step } from 'signup-constants/Step';
import { fetchPublicVisitorContext } from '../visitor-context-fetch/fetchPublicVisitorContext';
import { handleVisitorContextSuccess } from '../visitor-context-fetch/handleVisitorContextResponse';
import { EndpointKey } from './EndpointKey';
export const EndpointsPrefilling = {
  [EndpointKey.CompanyInfo]: {
    getRequestData: () => [Data.Email],
    handleError: handleCompanyInfoError,
    handleSuccess: handleCompanyInfoSuccess,
    method: companyInfo,
    stateCheck: state => {
      const isVerificationTypeSet = Boolean(getVerificationType(state));
      return isVerificationTypeSet && isStepInNextOrCurrentStep(state, [Step.CompanyDomain, Step.CompanyName, Step.Industry]);
    }
  },
  [EndpointKey.VisitorContextFetch]: {
    handleSuccess: handleVisitorContextSuccess,
    method: fetchPublicVisitorContext,
    reduxActionType: VisitorContextActionTypes.Fetch
  },
  [EndpointKey.GetRecommendedHublet]: {
    method: getRecommendedHublet,
    handleSuccess: (response, dispatch) => {
      dispatch(setSignupDataValue(Data.HubletSelection, response.region));
    },
    reduxActionType: FlowActionTypes.Load
  }
};